import React from "react";
import "./styles.scss";

const SelectBox = ({ title, options, value, onChange, name, disabled }) => {
  return (
    <div>
      <select
        name={name}
        disabled={disabled}
        onChange={onChange}
        value={value}
        className="select_box"
      >
        <option value="" defaultValue disabled>
          {title}
        </option>
        {options.map((item, index) => (
          <option name={item.title} value={item.value} key={item.value}>
            {item.title}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectBox;
